import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link';

const CarrierLink = ({ trackingUrl, children, ...props }) => (
  <Link href={trackingUrl} {...props}>
    {children}
  </Link>
);

CarrierLink.propTypes = {
  color: PropTypes.string,
  children: PropTypes.string,
  trackingUrl: PropTypes.string,
};

export default CarrierLink;



// WEBPACK FOOTER //
// ./src/js/widgets/Status/CarrierLink.js